export default "__VITE_ASSET__BIaM2eqS__"